import api from './api-config';


export const getUserOrganizations = async () => {
    try {
        const response = await api.get('/organizations');
        return response.data;
    } catch (error) {
        console.error('Error fetching user organizations:', error);
        throw error;
    }
};

export const createOrganization = async (organizationData) => {
    try {
        const response = await api.post('/organizations', organizationData);
        return response.data;
    } catch (error) {
        console.error('Error creating organization:', error);
        throw error;
    }
};

// Organization management
export const getOrganizationDetails = async (orgId) => {
    try {
        const response = await api.get(`/organizations/${orgId}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching organization details for ${orgId}:`, error);
        throw error;
    }
};

export const updateOrganization = async (orgId, data) => {
    try {
        const response = await api.put(`/organizations/${orgId}`, data);
        return response.data;
    } catch (error) {
        console.error(`Error updating organization ${orgId}:`, error);
        throw error;
    }
};

export const getOrganizationUsers = async (orgId) => {
    try {
        const response = await api.get(`/organizations/${orgId}/users`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching users for organization ${orgId}:`, error);
        throw error;
    }
};

export const addUserToOrganization = async (orgId, userId, role = 'member') => {
    try {
        const response = await api.post(`/organizations/${orgId}/users`, {
            user_id: userId,
            role: role
        });
        return response.data;
    } catch (error) {
        console.error(`Error adding user to organization ${orgId}:`, error);
        throw error;
    }
};

export const removeUserFromOrganization = async (orgId, userId) => {
    try {
        const response = await api.delete(`/organizations/${orgId}/users/${userId}`);
        return response.data;
    } catch (error) {
        console.error(`Error removing user from organization ${orgId}:`, error);
        throw error;
    }
};

export const createDemoOrganization = async () => {
    try {
        const response = await api.post('/organizations/demo');
        return response.data;
    } catch (error) {
        console.error('Error creating demo organization:', error);
        throw error;
    }
};

export const getSetupProgress = async (orgId) => {
    try {
        const response = await api.get(`/organizations/${orgId}/setup-progress`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching setup progress for organization ${orgId}:`, error);
        throw error;
    }
};

export const updateSetupStep = async (orgId, step, action) => {
    try {
        const response = await api.put(`/organizations/${orgId}/setup-progress`, {
            step,
            action,
        });
        return response.data;
    } catch (error) {
        console.error(`Error updating setup step for organization ${orgId}:`, error);
        throw error;
    }
};

export const generateDemoData = async (orgId, options = {}) => {
    const { force = false, seed = null, tagTemplateId = 'saas_business' } = options;
    const params = new URLSearchParams();
    if (force) params.append('force', 'true');
    if (seed !== null) params.append('seed', seed.toString());
    if (tagTemplateId) params.append('tag_template_id', tagTemplateId);

    const queryString = params.toString();
    const url = `/organizations/${orgId}/generate-demo-data${queryString ? `?${queryString}` : ''}`;

    try {
        const response = await api.post(url);
        return response.data;
    } catch (error) {
        console.error(`Error generating demo data for organization ${orgId}:`, error);
        throw error;
    }
};
